import React, { useCallback, useContext, createContext, useState, useRef, useEffect, useMemo } from 'react';
import { ListGroup, Dropdown, Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ThemeSwitcher from 'src/components/Actions/themeToggle';
import Styles from 'src/components/themeStyle';
import ChatList from './ChatList';
import { ConfigContext } from '../../../../contexts/ConfigContext';
import useAuth from '../../../../hooks/useAuth';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import SettingsIcon from 'src/assets/images/common/settings.svg';
import Spinner from 'react-bootstrap/Spinner';
import PathCalendar from '../../../../views/pages/amc-insights/components/path-conversion-charts/amc-path-calendar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Tooltip } from '@mui/material';
import infoIcon from 'src/assets/images/common/info.svg';
import ResetIcon from 'src/assets/images/common/reset.svg';
import AmcMultilevel from '../../../../views/pages/amc-insights/components/path-conversion-charts/amc-multi-level';
import 'src/views/pages/amc-insights/path-to-conversion.scss';
import 'src/assets/scss/profile-new.scss';
import { getDspDetails } from 'src/views/pages/utils'
import CableIcon from '@mui/icons-material/Cable';
import IconButton from '@mui/material/IconButton';

// import 'react-date-range/dist/styles.css';
// import 'react-date-range/dist/theme/default.css';
// import { DateRangePicker } from 'react-date-range';
// import { Popover, Whisper } from 'rsuite';
// import { addDays } from 'date-fns';
import queryString from 'query-string';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import { Maximize, Bell, User, Users, LogOut, UserCheck, FileText, Minimize, Settings, CloudDrizzle, Crosshair, PhoneCall, Menu, X, Key, Tool } from 'react-feather';
import { ThemeContext, ThemeProvider } from 'src/providers/themeProvider';
import Search from 'src/components/Form/search';
import { SearchFilter } from 'src/helper/search';
import ReactGA from 'react-ga4';
import { sanitizeValue, generateUTCtimestamp } from 'src/utils/custom-formatters';
import FlipkartProfiles from './FlipkartProfiles';

import { CustomCountryDropdown } from 'src/components/CountryFlagSelect';
import { useCookies } from 'react-cookie';
import BugModal from 'src/views/pages/targetting/bugModal';
import { COUNTRIES, MAIN_URL } from 'src/config/constant';
import { getCountryFlagUrl, yetToOnboarded } from 'src/utils/utils';
import { useCommonContext } from 'src/contexts/CommonContext';
import useWindowSize from '../../../../hooks/useWindowSize';
import AppCalendar, { TimeBadgeClock } from 'src/views/pages/targetting/calendar';
import WeeklyCalendar, { TimeBadgeClock as WeeklyTimeBadgeClock } from 'src/views/pages/targetting/week-calendar';

import { addDays, isToday, subDays, format, subWeeks, startOfWeek, isSameDay, startOfDay } from 'date-fns';
import { getNewPayloadDateRange, usePayloadContext } from 'src/contexts/PayloadContext';
import TargetingSettings from './settings-v2';
import TargetingDSPSettings from './settings-v3';
import ClearCrossFilter from './Clear';
import { replaceString } from 'src/api/demo';
import useApi from 'src/hooks/useApi';
import services from 'src/api/service';
import { getUserIdentity } from 'src/api/identity';
import GlobalFilter from './globalFilter/index';
import MyntraProfiles from './MyntraProfiles';
import BlinkitProfiles from './BlinkitProfiles';
import InstamartProfiles from './InstamartProfiles';
import DropDownAMS from 'src/components/drop-down-ams';
import StarIcon from 'src/assets/icons/StarIcon';
import AccountsReset from './AccountsReset';
import { useAmzDspContext } from 'src/contexts/AmzDspContext';
import Wallet from '../NavRight/wallet/index'
import AmazonProfiles from './AmazonProfiles';
import ZeptoProfiles from './ZeptoProfiles';
import BigbasketProfiles from './BigbasketProfiles';
import DropDownDistributor from 'src/components/drop-down-distributor';
import { Notification } from 'src/views/notification';
import { FormControlLabel, FormGroup, Switch } from '@mui/material';
import { idb } from 'src/utils/idb';
import ProcessNotification from 'src/layouts/AdminLayout/NavBar/NavRight/ProcessNotification';
import useDefaultProfile from 'src/hooks/useDefaultProfile';
import { removePylonWidget } from 'src/hooks/usePylonChat';
import { isUserFromAllowedDomain } from 'src/utils/emailUtils';
import RankingWallet from './ranking-wallet';
import { formatDate } from 'src/utils/custom-formatters';
import { Clock } from 'src/views/pages/targetting/calendar';
import { getTimeZoneAbrv, getCurrentDateInProfileTimezone } from 'src/config/timezone';
import CustomTooltip from 'src/components/Popover/CustomTooltip.js';

const StyleTag = () => {
  const [themeMode, setTheme] = useContext(ThemeContext);
  console.log('themeMode', themeMode.theme);
  return (
    <div>
      <style>{Styles(themeMode.theme)}</style>
    </div>
  );
};

// const defaultActiveData =
export const DataPathContext = createContext();
export const CampaignContext = createContext();

const NavRight = ({ activeProfiles, isFullScreen, enableFullscreen, listTotalCount }) => {

  const location = useLocation();

  const isDaypartingLogPage = useMemo(() => {
    let urlParts = location.pathname.split('/');
    const slotType = urlParts[2] || undefined; // ':ruleType'
    const slotId = urlParts[3] || undefined;   // ':slotId'
    const slotAction = urlParts[4] || undefined; // 'update|revert'
    return location.pathname?.includes('amazon-dayparting-schedule-log') && 
           Boolean(slotType) && Boolean(slotId) && Boolean(slotAction);
  }, [location.pathname]);


  const isRuleBasedLogPage = useMemo(() => {
    let urlParts = location.pathname.split('/');
    const typeRule = urlParts[2] || undefined; // ':type_rule'
    const typeRuleId = urlParts[4] || undefined; // ':type_rule_id'  
    const checkId = urlParts[6] || undefined; // ':check_id'
    return location.pathname?.includes('view-logs-notifications') && 
           Boolean(typeRule) && Boolean(typeRuleId) && Boolean(checkId);
  }, [location.pathname]); 

  const hideSectionsFortheLogPages = useMemo(() => {
    return isDaypartingLogPage || isRuleBasedLogPage;
  }, [isDaypartingLogPage, isRuleBasedLogPage]);
  
  const { payloadState, payloadDispatch } = usePayloadContext();
  const isFlipKart = window.location.href.indexOf('/flipkart') > -1;
  const isInstamart = window.location.href.indexOf('/instamart') > -1;
  const isConnectMcp = window.location.href.indexOf('/connect-mcp') > -1;
  const isProfile = window.location.href.indexOf('/profile') > -1;
  const { commonState, commonDispatch } = useCommonContext()
  const [theme] = useContext(ThemeContext);
  const windowSize = useWindowSize();
  const isMobileOrTablet = windowSize.width < 992;

  const isNavigatingButton = useMemo(() => {
    const User = JSON.parse(localStorage.getItem('User'));
    const isMCP = User?.metaDetails?.from === 'mcp';
    return isMCP && (isConnectMcp || isProfile);
  }, [location.pathname]);

  const hideBillingCalendar = useMemo(() => {
    const urlSearchParams = queryString.parse(location.search);
    return (
      (location.pathname === '/billing-payments' &&
        (!urlSearchParams.type ||
          urlSearchParams.type === 'recharge' ||
          urlSearchParams.type === 'account-details' ||
          (urlSearchParams.type === 'setting' && !urlSearchParams.account) ||
          urlSearchParams.type === 'offline-wallet' ||
          urlSearchParams.type === 'agency-account-details')) ||
      (location.pathname.includes('/sponsored-ads') &&
        (location.pathname.includes('settings') ||
          location.pathname.includes('coupons') ||
          location.pathname.includes('managed-service') ||
          location.pathname.includes('account-manager') ||
          location.pathname.includes('invoice'))) ||
      location.pathname === '/user-activity/retention-dashboard'
    );
  }, [location.pathname, location.search]);

  const hideWallet = useMemo(() => {
    const urlSearchParams = queryString.parse(location.search);
    return (
      location.pathname === '/billing-payments' &&
      (!urlSearchParams.type || urlSearchParams.type === 'dashboard' || urlSearchParams.type === 'setting' || urlSearchParams.type === 'offline-wallet' || (urlSearchParams.type === 'invoice' && urlSearchParams.view === 'admin'))
    );
  }, [location.pathname, location.search]);

  const hideGlobalFilter = useMemo(() => {
    const urlSearchParams = queryString.parse(location.search);
    return (
      location.pathname === '/billing-payments' &&
      (!urlSearchParams.type || urlSearchParams.type === 'dashboard' || urlSearchParams.type === 'setting' || urlSearchParams.type === 'offline-wallet' || (urlSearchParams.type === 'invoice' && urlSearchParams.view === 'admin'))
    );
  }, [location.pathname, location.search]);

  const pathname = window.location.pathname;
  const isDspCampaignCreateOrUpdate = pathname.includes('/amazon-dsp/campaign/') || pathname.includes('/amazon-dsp/adgroup/');

  const hideAccountsDropdown = useMemo(() => {
    const urlSearchParams = queryString.parse(location.search);
    return (
      location.pathname === '/billing-payments' &&
      (!urlSearchParams.type || urlSearchParams.type === 'dashboard' || urlSearchParams.type === 'setting' || urlSearchParams.type === 'offline-wallet' || (urlSearchParams.type === 'invoice' && urlSearchParams.view === 'admin') || urlSearchParams.type === 'hector-fee-invoice' || urlSearchParams.type === 'transaction-charges-invoice')
    );
  }, [location.pathname, location.search]);

  const [ParseData, setParseData] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('User')) || null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    // Update ParseData when localStorage changes
    const updateParseData = () => {
      try {
        const userData = JSON.parse(localStorage.getItem('User'));
        setParseData(prevData => {
          // Only update if data actually changed to avoid unnecessary re-renders
          if (JSON.stringify(prevData) !== JSON.stringify(userData)) {
            return userData;
          }
          return prevData;
        });
      } catch {
        setParseData(null);
      }
    };

    // Listen for storage events (when localStorage changes in other tabs/windows)
    window.addEventListener('storage', updateParseData);
    
    // Listen for focus events (when user navigates back to this tab)
    window.addEventListener('focus', updateParseData);
    
    // Also check on component mount and when location changes
    updateParseData();

    return () => {
      window.removeEventListener('storage', updateParseData);
      window.removeEventListener('focus', updateParseData);
    };
  }, [location.pathname]);
  
  const isSuperAdmin = useMemo(() => {
    return String(process.env.REACT_APP_ADMIN_ACCESS_EMAIL || '').indexOf(ParseData?.email) > -1;
  }, [ParseData?.email]);
  const isAgencyUser = useMemo(() => {
    return ParseData?.isAgency;
  }, [ParseData?.isAgency]);

  const clientPreference = useMemo(() => {
    if (window.location.href.indexOf('/flipkart') > -1) return 'flipkartProfile';
    if (window.location.href.indexOf('/myntra') > -1) return 'myntraProfile';
    if (window.location.href.indexOf('/zepto') > -1) return 'zeptoProfile';
    if (window.location.href.indexOf('/bigbasket') > -1) return 'bigbasketProfile';
    if (window.location.href.indexOf('/blinkit') > -1) return 'blinkitProfile';
    if (window.location.href.indexOf('/instamart') > -1) return 'instamartProfile';
    return 'selectedProfileId';
  }, [window.location.href]);

  const localSelectedProfileId = useMemo(() => {
    return JSON.parse(sessionStorage.getItem(clientPreference))
  }, [sessionStorage.getItem(clientPreference)]);

  const selectedLocalCountry = useMemo(() => JSON.parse(localStorage.getItem('selectedCountry')), [localStorage.getItem('selectedCountry')]);

  const doLogoutSettings = useApi(services.postService);
  const dogetWeeklyAndBiweekly = useApi(services.postService);
  const doGetLastUpdateTime = useApi(services.postService);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [lastUpdateTime, setLastUpdateTime] = useState(null);
  const [showReAuthModal, setShowReAuthModal] = useState(null); // Store the revoked account object

  const handleCloseLogoutModal = () => setShowLogoutModal(false);
  const [storedCampaignsData, setStoredCampaignsData] = useState([]);

  useEffect(() => {
    // TODO: Update necessory properties
    commonDispatch({
      type: 'UPDATE_USER',
      payload: {
        fullName: ParseData?.fullName || '',
        firstName: ParseData?.firstName || '',
        phoneNumber: ParseData?.phoneNumber || '',
        email: ParseData?.email || '',
        token: ParseData?.token || '',
        profileStatus: ParseData?.profileStatus || false,
      }
    });
  }, []);

  const [showDropdown, setShowDropdown] = useState(false);
  const [showProfDropdown, setShowProfDropdown] = useState(false);
  const [showAccDropdown, setShowAccDropdown] = useState(false);
  const [showFlagDropdown, setShowFlagDropdown] = useState(false);
  const [profileResponse, setProfileResponse] = useState({ data: [activeProfiles], filteredData: [] });

  const configContext = useContext(ConfigContext);
  const { logout } = useAuth();
  const { rtlLayout } = configContext.state;
  const queryParams = window.location.href.substring(window.location.href.lastIndexOf('/'));
  const [listOpen, setListOpen] = useState(false);
  const [activeProfilesAMS, setAMSactiveProfiles] = useState({ data: [], filteredData: [] });
  const [valueSearch, setValueSearch] = useState('');
  const [defaultActive, setDefaultActive] = useState(localSelectedProfileId ? [localSelectedProfileId] : activeProfiles?.slice(0, 1));
  const [countrySelected, setCountrySelected] = useState(selectedLocalCountry ? selectedLocalCountry : COUNTRIES?.[0]);
  const [receiveData, setReceiveData] = useState();
  const [receivedCampaigns, setCampaignsData] = useState();
  const [calendarToggle, setCalendarToggle] = useState(false);
  const dateRangeConst = useRef(JSON.stringify(payloadState?.dateRange));
  const [historyPtcDate, setHistoryPtcDate] = useState();
  const [comparisonDates, setComparisonDate] = useState();
  const [comparisonDatesFetch, setcomparisonDatesFetch] = useState(false);
  const { amzDspState, amzDspDispatch } = useAmzDspContext();
  const [weeklyBiweelyData, setWeeklyBiweelyData] = useState({});
  const [amcCompare, setAmcCompare] = useState(window.location.pathname.includes('amazon/search-query-performance'));
  const [showDspBrandSelectModal, setShowDspBrandSelectModal] = useState(false);

  const newCurrentDay = new Date(receiveData?.currentDay);
  const newEndDay = new Date(receiveData?.endDay);

  const isSQPPath = window.location.pathname.includes('amazon/search-query-performance');
  if (receiveData?.activePreset !== "custom" && !isSQPPath) {
    newCurrentDay.setDate(newCurrentDay.getDate() + 1);
    newEndDay.setDate(newEndDay.getDate() + 1);
  }

  useEffect(() => {
    if (amcCompare && receiveData?.currentDay && receiveData?.endDay) {
      const currentStart = new Date(receiveData.currentDay)
      const currentEnd = new Date(receiveData.endDay);
      
      const inBetweenMs = currentEnd.getTime() - currentStart.getTime();
      const inBetweenDaysCount = Math.ceil(inBetweenMs / (1000 * 60 * 60 * 24));
      
      const compareEndDate = new Date(new Date(currentStart).setDate(currentStart.getDate()));
      
      const compareStartDate = new Date(new Date(compareEndDate).setDate(compareEndDate.getDate() - inBetweenDaysCount));
      
      setReceiveData(prevData => ({
        ...prevData,
        compareStartDate: compareStartDate.toISOString().split('T')[0],
        compareEndDate: compareEndDate.toISOString().split('T')[0],
        compare: amcCompare
      }));
    } else if (!amcCompare && receiveData) {
      setReceiveData(prevData => {
        const { compareStartDate, compareEndDate, compare, ...rest } = prevData;
        return rest;
      });
    }
  }, [amcCompare, receiveData?.currentDay, receiveData?.endDay]);

  let history = useHistory();

  const setDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const setProfDropdown = () => {
    setShowProfDropdown(!showProfDropdown);
  };

  const setAccDropdown = () => {
    setShowAccDropdown(!showAccDropdown);
    console.log({ localSelectedProfileId, showAccDropdown });
    if (!showAccDropdown) {
      console.log({ localSelectedProfileId, showAccDropdown });
      setCountrySelected({ code: localSelectedProfileId.countryCode, country_code: localSelectedProfileId.countryCode });
    }
  };

  const setFlagDropdown = () => {
    setShowFlagDropdown(!showFlagDropdown);
  };

  const handleSearchInput = async (e) => {
    const keyword = e.target.value;
    console.log('keyword', keyword);
    const { data, filteredData } = await SearchFilter(profileResponse.data, keyword);

    if (keyword !== '') {
      setProfileResponse({ data, filteredData });
      console.log('KEYWORD_____1', keyword);
    } else {
      setProfileResponse({ data, filteredData });
    }
    setValueSearch(keyword);
  };

  const filteredProfile = () => {
    console.log('getProfileRows', profileResponse.filteredData.length ? profileResponse.filteredData : profileResponse.data);
    return profileResponse.filteredData.length ? profileResponse.filteredData : profileResponse.data;
  };

  useEffect(() => {
    if (showAccDropdown) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  }, [showAccDropdown]);

  const [cookies, setCookie, removeCookie] = useCookies();

  useEffect(() => {
    console.log('queryParams222', queryParams);

    if (String(queryParams) === '/targeting-summary') {
      console.log('queryParams---->', queryParams);

      history.push(MAIN_URL);
    }
    if (activeProfiles && Array.isArray(activeProfiles) && activeProfiles?.length) {
      console.log('defaultActive-----', activeProfiles);
      setAMSactiveProfiles({ data: activeProfiles, filteredData: [] });
      setDefaultActive(
        localSelectedProfileId && Object.keys(localSelectedProfileId).length > 0 ? [localSelectedProfileId] : activeProfiles?.slice(0, 1)
      );
      // if (!localSelectedProfileId || (localSelectedProfileId && Object.keys(localSelectedProfileId).length === 0)) {
      //   let defaultSelectedId = activeProfiles?.slice(0, 1);
      //   console.log('selectedProfileId', defaultSelectedId);
      //   sessionStorage.setItem('selectedProfileId', JSON.stringify(defaultSelectedId[0]));
      //   setCookie('last-profile', defaultSelectedId[0])
      // }
    }
  }, [activeProfiles]);

  //   useEffect(()=>{
  //     if(activeProfilesAMS?.length){
  //     setDefaultActive(activeProfilesAMS?.slice(0, 1))
  // }
  // },[activeProfilesAMS])

  const { removeDefaultProfile } = useDefaultProfile();

  const handleSelect = async (selectedItem) => {
    if (selectedItem?.isDspPendingRequest) {
      handleDspBrandSelect();
      return;
    }

    document.getElementById('fullPageLoader').style.visibility = 'visible';

    // if(selectedItem && Object.keys(selectedItem).length > 0 && selectedItem?.profileId && window.location.href.indexOf('/amazon/targeting') > -1) {
    //   await removeDefaultProfile(selectedItem);
    // }

    setDefaultActive([selectedItem]);
    sessionStorage.setItem('selectedProfileId', JSON.stringify(selectedItem));
    localStorage.removeItem('brandConfigureIgnore');
    if(selectedItem?.ams?.groupedAccounts?.length > 0) {
      sessionStorage.setItem('selectedGroupedProfileId', JSON.stringify(selectedItem))
    }
    localStorage.setItem('selectedCountry', JSON.stringify(selectedItem?.countryCode));
    // setCookie('last-profile', selectedItem);
    setTimeout(() => {
      if (selectedItem?.dsp_only == true || (window.location.href.includes('dsp')&& selectedItem?.dsp?.length > 0 && Boolean(selectedItem?.dsp?.[0]?.dspId || ''))) {
        window.location.href = '/amazon-dsp/campaign';
      } else if (window.location.href.indexOf('plan-expired') > -1) {
        window.location.href = '/amazon/targeting';
      } else if(selectedItem?.ams?.connected == false) {
        window.location.href = '/amazon-audience-report';
      } else if(selectedItem?.ams?.connected == true) {
        window.location.href = '/amazon/targeting';
      } else {
        window.location.reload();
      }
    }, 100);
    // window.location.reload();
    setShowAccDropdown(!showAccDropdown);
  };

  // Function to handle selection of DSP brand which is not active yet
  const handleDspBrandSelect = () => {
    setShowDspBrandSelectModal(true);
  };

  // console.log("defaultActive", defaultActive)
  // useEffect(()=>{
  //   if(localSelectedProfileId)
  //   console.log("selectedProfileId")
  //   sessionStorage.setItem('selectedProfileId', JSON.stringify(defaultActive))
  // },[defaultActive])

  // const [datePickerOpen, setDatePickerOpen] = useState(false)

  // const [state, setState] = useState([
  //   {
  //     startDate: new Date(),
  //     endDate: addDays(new Date(), 7),
  //     key: 'selection'
  //   }
  // ]);

  // function DatePicker() {

  //   if (datePickerOpen === false) {
  //     setDatePickerOpen(true)

  //   } else if (datePickerOpen === true) {
  //     setDatePickerOpen(false)
  //   }
  // }

  // const speaker = (
  //   <Popover style={{ zIndex: "10000" }}>
  //     <div>

  //       <DateRangePicker
  //         onChange={item => setState([item.selection])}
  //         showSelectionPreview={true}
  //         moveRangeOnFirstSelection={false}
  //         months={2}
  //         ranges={state}
  //         direction="horizontal"
  //       ></DateRangePicker>
  //       {console.log("datepicker") }
  //       <div className="text-right position-relative rdr-buttons-position mt-2 mr-3">
  //         <button
  //           className="btn btn-transparent text-danger rounded-0 px-4" onClick={DatePicker}
  //         >
  //           Close
  //         </button>
  //       </div>
  //     </div>

  //   </Popover>
  // );

  const searchInputHandle = async (e) => {
    const keyword = e.target.value;
    console.log('keyword', keyword);
    const { data, filteredData } = await SearchFilter(activeProfilesAMS.data, keyword);

    if (keyword !== '') {
      setAMSactiveProfiles({ data, filteredData });
    } else {
      setAMSactiveProfiles({ data, filteredData });
    }
    setValueSearch(keyword);
  };

  const getTableRows = () => {
    console.log('getTAbleRows', activeProfilesAMS.filteredData);
    const getProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));
    if (valueSearch !== '') {
      const defaultProfiles = activeProfilesAMS.filteredData.filter((dataItem) => dataItem.profileId == getProfile?.profileId);
      const nonDefaultProfiles = activeProfilesAMS.filteredData.filter((dataItem) => dataItem.profileId != getProfile?.profileId);
      return [...defaultProfiles, ...nonDefaultProfiles];
    } else {
      const defaultProfiles = activeProfilesAMS.data.filter((dataItem) => dataItem.profileId == getProfile?.profileId);
      const nonDefaultProfiles = activeProfilesAMS.data.filter((dataItem) => dataItem.profileId != getProfile?.profileId);
      return [...defaultProfiles, ...nonDefaultProfiles];
    }
  };

  // console.log("getTableRows", getTableRows(), activeProfilesAMS.data)

  const handleLogoutHandle = () => {
    setShowLogoutModal(true);
    //sweetAlertHandler({ type: 'alert', text: 'Are you sure you want to logout?', showConfirmButton: true, CancelButton: true });
  };

  // const handleLogout = async () => {
  //   try {
  //     doLogoutSettings.request({
  //       url: '/auth/logout',
  //       nodeAPI: 1,
  //       payload: {},
  //     });
  //     await logout();
  //     ReactGA.gtag('event', 'Logged Out', {
  //       event_category: 'User',
  //       event_label: ParseData && Object.keys(ParseData).length > 0 && 'email' in ParseData ? ParseData.email : '',
  //       value: generateUTCtimestamp()
  //     });
  //     const profileName = `/login?userId=${ParseData.email}&type=stop-viewing&utcTime=${generateUTCtimestamp()}&userName=${[
  //       ParseData.firstName,
  //       ParseData.lastName
  //     ]
  //       .filter((value) => value != '')
  //       .join(' ')}`;
  //     ReactGA.send({ hitType: 'pageview', page: location.pathname, title: profileName });
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  useEffect(() => {
    if (!String(location.pathname).includes('/addaccount')) {
      dogetWeeklyAndBiweekly.request({
        url: '/amc/amcOnboardedusers',
        nodeAPI: 1,
        payload: {}
      });
    }
  }, [location.pathname]);


  useEffect(() => {
    const { loading, data } = dogetWeeklyAndBiweekly;
    if (!loading && data && data.success == true) {
      setWeeklyBiweelyData({
        BiweeklyDate: data?.BiWeeklyDate,
        WeeklyData: data?.WeeklyDate
      });
    }
  }, [dogetWeeklyAndBiweekly.loading]);

  const handleLogout = async () => {
    setShowLogoutModal(false)
    removePylonWidget()
    history.replace('/logout')
  };


  const sweetAlertHandler = (alert) => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: alert.text,
      type: alert.type,
      timer: alert.timer,
      showConfirmButton: alert.showConfirmButton,
      didClose: alert.action
        ? alert.action
        : () => {
          console.log('Actioned');
        },
      allowOutsideClick: false,
      showCancelButton: alert.CancelButton
    }).then((result) => {
      if (result.isConfirmed) {
        handleLogout();
        // history.push('/');
        // ReactGA.gtag('event', 'Logged Out', {
        //   event_category: 'User',
        //   event_label: ParseData && Object.keys(ParseData).length > 0 && 'email' in ParseData ? ParseData.email : '',
        //   value: generateUTCtimestamp()
        // });
        const profileName = `/login?userId=${ParseData.email}&type=stop-viewing&utcTime=${generateUTCtimestamp()}&userName=${[
          ParseData.firstName,
          ParseData.lastName
        ]
          .filter((value) => value != '')
          .join(' ')}`;
        // ReactGA.send({ hitType: 'pageview', page: location.pathname, title: profileName });
        // ReactGA.event({
        //   category: 'User',
        //   action: 'Logout',
        //   label: ParseData && Object.keys(ParseData).length > 0 && 'firstName' in ParseData ? `${ParseData.firstName} is Logging out` : "User is Logging Out",
        //   value: ParseData && Object.keys(ParseData).length > 0 && 'email' in ParseData ? ParseData.email : ""
        // });
      } else if (result.isDenied) {
        // Swal.fire('Changes are not saved', '', 'info')
      }
    });
  };

  const handleSelectCountry = (country) => {
    console.log("handleSelectCountry", country)
    setCountrySelected(country);
    localStorage.setItem('selectedCountry', JSON.stringify(country));
  };

  // Debounced window focus handler - DISABLED for sessionStorage
  // Since sessionStorage is tab-specific, we don't need to reload on focus
  // Each tab maintains its own profile selection independently
  useEffect(() => {
    // COMMENTED OUT: This was causing unnecessary reloads when switching tabs
    // With sessionStorage, each tab has its own storage, so no sync needed
    /*
    let reloadTimeout = null;
    let lastFocusTime = 0;
    const RELOAD_DEBOUNCE_TIME = 5000; // 5 seconds minimum between reloads

    const handleWindowFocus = () => {
      const now = Date.now();
      
      // Prevent reload if we just focused recently
      if (now - lastFocusTime < RELOAD_DEBOUNCE_TIME) {
        console.log('Window focus ignored - too recent');
        return;
      }
      
      lastFocusTime = now;
      
      // Clear any existing timeout
      if (reloadTimeout) {
        clearTimeout(reloadTimeout);
      }
      
      // Debounce the reload check
      reloadTimeout = setTimeout(() => {
        try {
          const localProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));
          
          // Only reload if there's a significant profile mismatch
          if (localProfile && defaultActive.length > 0) {
            const hasMismatch = defaultActive.some((element) => 
              localProfile?.profileId && localProfile.profileId !== element?.profileId
            );
            
            if (hasMismatch) {
              console.log('Profile mismatch detected, reloading...', { localProfile, defaultActive });
              window.location.reload();
            } else {
              console.log('Profile sync check passed');
            }
          }
        } catch (error) {
          console.error('Error in window focus handler:', error);
        }
      }, 1000); // 1 second delay to prevent rapid reloads
    };

    // Only add listener for non-Flipkart and non-Instamart pages
    if (isAmazon) {
      window.addEventListener('focus', handleWindowFocus);
    }
    
    return () => {
      if (reloadTimeout) {
        clearTimeout(reloadTimeout);
      }
      if (isAmazon) {
        window.removeEventListener('focus', handleWindowFocus);
      }
    };
    */
  }, [defaultActive]);



  const isCategorizationShow = useMemo(() => window.location.href.indexOf('/flipkart') > -1 || window.location.href.indexOf('/amazon') > -1 || window.location.href.indexOf('/myntra') > -1 || window.location.href.indexOf('/blinkit') > -1 || window.location.href.indexOf('/instamart') > -1 || window.location.href.indexOf('/zepto') > -1 || window.location.href.indexOf('/bigbasket') > -1 || localSelectedProfileId?.dsp_only , [window.location.href, localSelectedProfileId]);

  const [selectedDateRange, setSelectedDateRange] = useState({});
  const [showProcessNotification, setShowProcessNotification] = useState(true);

  const datePayload = useMemo(() => payloadState.dateRange, [payloadState.dateRange])

  const calendarApply = useCallback((receivedCampaignData) => {
    console.debug('[calendarApply] called with receivedCampaignData:', receivedCampaignData);
    console.debug('[calendarApply] Path does NOT include amazon/search-query-performance, dispatching UPDATE_CALENDAR_DATES with:', { receiveData, receivedCampaignData });
    payloadDispatch({ type: 'UPDATE_CALENDAR_DATES', payload: { receiveData, receivedCampaignData } });
    console.debug('[calendarApply] Setting historyPtcDate to:', receiveData);
    setHistoryPtcDate(receiveData);
    console.debug('[calendarApply] Setting calendarToggle to false');
    setCalendarToggle(false);
  }, [payloadDispatch, payloadState.dateRange, receiveData, amcCompare]);

  const handleCampaignData = (receivedCampaignData) => {
    let campaignsArray = receivedCampaignData?.campaigns || [];
    if (campaignsArray.length === 0) {
      campaignsArray = ['All'];
    }
    setCampaignsData(receivedCampaignData);
    calendarApply(receivedCampaignData);
    setStoredCampaignsData(campaignsArray);
  }

  const showPtcCalendar = (e) => {
    setCalendarToggle(e);
    if(e) {
      setHistoryPtcDate(receiveData);
    }
    else {
      setReceiveData(historyPtcDate);
    }
  }

  useEffect(() => {
    setHistoryPtcDate('');
    setReceiveData('');
    // Set comparison to true by default for SQP page
    setAmcCompare(window.location.pathname.includes('amazon/search-query-performance'));
  }, [window.location.href])

  const wrapperRef = useRef("ptcCalendat");
  useClickOutside(wrapperRef, () => {
    showPtcCalendar(false);
  });

  const handleDataReceive = (receivedData) => {
    setReceiveData(receivedData); // Update the state with data received from ClassComponent
    if(window.location.pathname === '/amazon-custom-attribution' && receivedData && receivedData.currentDay !== receivedData.endDay) {
      comparisonFunction(receivedData);
    }
    else {
      setComparisonDate(false);
    }
  };

  const comparisonFunction = (receivedData) => {
    setComparisonDate('');
    const diffInMilliseconds = new Date(receivedData.endDay) - new Date(receivedData.currentDay);
    const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
    let firstDate = new Date(
      new Date(receivedData.currentDay.toISOString().split('T')[0]).setDate(
        new Date(receivedData.currentDay.toISOString().split('T')[0]).getDate() - diffInDays
      )
    )
      .toISOString()
      .split('T')[0];
    let endDate = new Date(
      new Date(receivedData.endDay.toISOString().split('T')[0]).setDate(new Date(receivedData.endDay.toISOString().split('T')[0]).getDate() - diffInDays)
    )
      .toISOString()
      .split('T')[0];
    setComparisonDate(new Date(firstDate).toDateString() + ' - ' + new Date(endDate).toDateString())

  }

  const getCurrentDateDetails = () => {
    if(!comparisonDatesFetch){
      let firstDate = (new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 6) % 7 - 14)))
      let endDate = new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 7) % 14));
      if(window.location.pathname === '/amazon-custom-attribution' && firstDate !== endDate) {
        comparisonFunction({
          currentDay: firstDate,
          endDay: endDate
        })
      }
      setcomparisonDatesFetch(true);
      return firstDate.toDateString() + ' - ' + endDate.toDateString();
    }
  }

  function useClickOutside(ref, onClickOutside) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (event.target.getAttribute('alt') !== 'multilevel' && ref.current && typeof(ref.current) !== 'string' && !ref.current.contains(event.target)) {
          onClickOutside();
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, onClickOutside]);
  }

  const handleToggleCalendar = () => {
    showPtcCalendar(!calendarToggle)
  }

  useEffect(() => {
    const { loading, data } = doLogoutSettings;
    if(!loading && data && data?.success) {
      setShowLogoutModal(false);
      logout();
    }
  }, [doLogoutSettings.loading])

  useEffect(() => {
    if (window.location.pathname.includes('amazon/marketing-stream')) {
      doGetLastUpdateTime.request({
        url: '/amazontodayDateRange/lastDateAndTime',
        nodeAPI: 1,
        payload: {
          start_date: formatDate(payloadState.dateRange.startDate),
          
        }
      });
    } else {
      setLastUpdateTime(null);
    }
  }, [location.pathname]);

  useEffect(() => {
    const { loading, data } = doGetLastUpdateTime;
    if (!loading && data && data?.success && data?.result?.max_time) {
      setLastUpdateTime(data.result.max_time);
    }
  }, [doGetLastUpdateTime.loading]);

  const isTodayDateRange = useMemo(() => {
    if (!payloadState?.dateRange) return false;
    const { key, startDate, endDate } = payloadState.dateRange;
    if (key === 'Today') {
      return true;
    }
    if (startDate && endDate) {
      const today = startOfDay(getCurrentDateInProfileTimezone());
      const start = startOfDay(new Date(startDate));
      const end = startOfDay(new Date(endDate));
      return isSameDay(today, start) && isSameDay(today, end);
    }
    return false;
  }, [payloadState?.dateRange]);

  const isAmazon = useMemo(() => window.location.href.includes('amazon'), [window.location.href]);
  const isMyntra = useMemo(() => window.location.href.includes('myntra'), [window.location.href]);
  const isBlinkit = useMemo(() => window.location.href.includes('blinkit'), [window.location.href]);
  const isZepto = useMemo(() => window.location.href.includes('zepto'), [window.location.href]);
  const isBigbasket = useMemo(() => window.location.href.includes('bigbasket'), [window.location.href]);
  const isBillingSponsoredAdsDashboard = useMemo(() => window.location.href.includes('sponsored-ads/dashboard') || window.location.href.includes('billing-payments'), [window.location.href]);

  const isUserManagementVisible = useMemo(() => {

    if(isAmazon) {
      return localSelectedProfileId && localSelectedProfileId?.accessLevel == 'Manager'
    }

    return localSelectedProfileId &&
      (isFlipKart || isInstamart || isMyntra || isBlinkit || isZepto || isBigbasket) &&
      (localSelectedProfileId?.accessLevel == 'Manager'  || localSelectedProfileId?.accessLevel == 'Admin')
  }, [localSelectedProfileId, isFlipKart, isInstamart, isMyntra, isBlinkit, isZepto, isBigbasket]);

  const masterFilter = JSON.parse(sessionStorage.getItem('master-account-filters')) || {}
  const dspDetails = localSelectedProfileId?.dsp ? getDspDetails(localSelectedProfileId, masterFilter) :{};
  
  const categorizationPath = useMemo(() => {
    if(dspDetails?.enabledAsOnlyDSP) return '/amazon-dsp-categorization';
    if (isAmazon) return '/amazon-categorization';
    if (isFlipKart) return '/flipkart-categorization';
    if (isInstamart) return '/instamart-categorization';
    if (isMyntra) return '/myntra-categorization';
    if (isBlinkit) return '/blinkit-categorization';
    if (isZepto) return '/zepto-categorization';
    if (isBigbasket) return '/bigbasket-categorization';

    return '';
  }, [isAmazon, isFlipKart, isInstamart, isMyntra, isBlinkit, isZepto, isBigbasket]);

  const userManagementPath = useMemo(() => {
    return `/${isFlipKart ? 'flipkart' : isInstamart ? 'instamart' : isMyntra ? 'myntra' : isAmazon ? 'amazon' : isBlinkit ? 'blinkit' : isZepto ? 'zepto': isBigbasket ? 'bigbasket' : ''}-user-management`;
  }, [isAmazon, isFlipKart, isInstamart, isMyntra, isBlinkit]);

  const textCategorizationPath = useMemo(() => {
    if (isAmazon) return '/amazon-text-categorization';
    if (isFlipKart) return '/flipkart-text-categorization';
    if (isInstamart) return '/instamart-text-categorization';
    if (isMyntra) return '/myntra-text-categorization';
    if (isBlinkit) return '/blinkit/text-categorization';
    if (isZepto) return '/zepto-text-categorization';
    if (isBigbasket) return '/bigbasket-text-categorization';

    return '';
  }, [isAmazon, isFlipKart, isInstamart, isMyntra, isBlinkit, isZepto, isBigbasket]);

  const isUserHasProfileAccess = useMemo(() => {
    return commonState?.userInfo?.profileStatus == true || commonState?.userInfo?.flipkartProfileStatus == true || commonState?.userInfo?.myntraProfileStatus == true || commonState?.userInfo?.blinkitProfileStatus == true || commonState?.userInfo?.instamartProfileStatus == true || commonState?.userInfo?.zeptoProfileStatus == true || commonState?.userInfo?.bigbasketProfileStatus == true;
  }, [commonState?.userInfo]);

  const isOnlyDSPProfileAccess = useMemo(() => { 
    return commonState?.userInfo?.DSPProfileStatus == true || commonState?.userInfo?.amcStatus == true
  }, [commonState?.userInfo]);

  const shouldShowWhatsappVerification = useMemo(() => {
    try {
      const User = JSON.parse(localStorage.getItem('User'));
      return window.location.href.includes('amazon') && User?.isWhatsappVerified !== true;
    } catch {
      return false;
    }
  }, [window.location.href, ParseData?.isWhatsappVerified]);

  useEffect(() => {
    console.log('defaultActive -- refresh', defaultActive);
    if(defaultActive?.length > 0 && isAmazon) {
      const mainProfile = defaultActive[0];
      // if(['Admin', 'Agency'].includes(mainProfile?.accessLevel))  {

        let revokedAccount = null;
        let revokedProfileId = null;

        // Check main profile
        if (mainProfile?.ams?.accessRevoked == true) {
          revokedAccount = mainProfile;
          revokedProfileId = mainProfile?.profileId;
        } 
        // Check grouped accounts
        else if (mainProfile?.ams?.groupedAccounts && Array.isArray(mainProfile?.ams?.groupedAccounts) && mainProfile?.ams?.groupedAccounts?.length > 0) {
          const revokedGroupedAccount = mainProfile?.ams?.groupedAccounts?.find(
            (account) => account?.ams?.accessRevoked == true
          );
          if (revokedGroupedAccount) {
            revokedAccount = revokedGroupedAccount;
            revokedProfileId = revokedGroupedAccount?.profileId;
          }
        }

        if (revokedAccount) {
          // Show re-authorization modal
          setShowReAuthModal(revokedAccount);
        }

      // }
    }
  }, [defaultActive, isAmazon])

  const Calendar = isSQPPath ? WeeklyCalendar : AppCalendar;

  return (
    <React.Fragment>
      {/* <ThemeProvider> */}
      {/* <div style={{ }}>
      <Whisper
        preventOverflow
        placement="auto"
        speaker={speaker}
        open={datePickerOpen}
        trigger="none"
      >
        <input
          id="formControlsTextB"
          type="text"
          label="Text"
          // value={}
          onClick={DatePicker}
        />
      </Whisper>
      </div> */}
      <ListGroup as="ul" bsPrefix=" " className="navbar-nav ml-auto" id="navbar-right">
       { (window.location.href.includes('amazon')) && <ListGroup.Item as="li" bsPrefix=" ">
          <ProcessNotification />
        </ListGroup.Item>}
        
        {!hideSectionsFortheLogPages && localSelectedProfileId?.ams?.groupedAccounts?.length > 0 && ((window.location.href.includes('dayparting') && !window.location.pathname.includes('/master-error-tracking/dayparting')) || window.location.href.includes('amazon-automated-rules') || window.location.href.includes('amazon/marketing-stream') || window.location.href.includes('campaign-drafts') || window.location.href.includes('smart-campaigns')) && !window.location.pathname.includes('master-dayparting-tracking') && (
          <ListGroup.Item as="li" bsPrefix=" ">
            <DropDownAMS />
          </ListGroup.Item>
        )}
        {localSelectedProfileId?.vendor?.distributorView && localSelectedProfileId?.vendor?.distributorView?.length > 0 && (window.location.href.includes('amazon-snapshot') || window.location.href.includes('amazon-master-overview') || window.location.href.indexOf('amazon/targeting') > -1) && (
          <ListGroup.Item as="li" bsPrefix=" ">
            <DropDownDistributor />
          </ListGroup.Item>
        )}
        {(window.location.href.indexOf('/amazon-ranking') > -1 || window.location.pathname === '/ranking-billing-payments') && <ListGroup.Item as="li" bsPrefix=" ">
          <RankingWallet />
        </ListGroup.Item>}
        {dspDetails?.amazonManaged?.toLowerCase() === "no" && (window.location.href.indexOf('/amazon-dsp/') > -1 || window.location.pathname =='/dsp-credit-top-up' || (window.location.pathname =='/billing-payments') && !hideWallet) ? <ListGroup.Item as="li" bsPrefix=" ">
          <Wallet />
        </ListGroup.Item> : null}
        {!isMobileOrTablet && ((window.location.href.indexOf('/amazon-master-overview') > -1 || window.location.href.indexOf('/amazon-snapshot') > -1 || window.location.href.indexOf('/amazon/targeting') > -1 || window.location.href.indexOf('/amazon-dsp') > -1  || (window.location.href.indexOf('billing-payments') > -1 || window.location.href.indexOf('amazon-ranking-configuration') > -1 || window.location.href.indexOf('/amazon/search-query-performance') > -1)) || window.location.href.indexOf('/flipkart-master-overview') > -1 || window.location.href.indexOf('/flipkart-snapshot') > -1) && !hideGlobalFilter ? <ListGroup.Item as="li" bsPrefix=" ">
          <GlobalFilter />
        </ListGroup.Item> : null}
        {window.location.href.indexOf('summary/flipkart') > -1 || window.location.href.indexOf('summary/instamart') > -1 || window.location.href.indexOf('summary/myntra') > -1 || window.location.href.indexOf('summary/blinkit') > -1 || window.location.href.indexOf('amazon/targeting') > -1 || window.location.href.indexOf('amazon/marketing-stream') > -1 || window.location.href.indexOf('summary/zepto') > -1 || window.location.href.indexOf('summary/bigbasket') > -1 || window.location.href.indexOf('amazon/search-query-performance') > -1 || window.location.href.indexOf('amazon-ranking-dashboard') > -1 || window.location.href.indexOf('amazon-dsp/reports') > -1?
          <ClearCrossFilter /> : null}
        { !isMobileOrTablet && (window.location.href.indexOf('summary/flipkart') > -1 || window.location.href.indexOf('summary/instamart') > -1 || window.location.href.indexOf('summary/myntra') > -1 || window.location.href.indexOf('summary/blinkit') > -1 || window.location.href.indexOf('amazon/targeting') > -1 || window.location.href.indexOf('amazon/marketing-stream') > -1 || window.location.href.indexOf('summary/zepto') > -1 || window.location.href.indexOf('summary/bigbasket') > -1  || window.location.href.indexOf('amazon/search-query-performance') > -1 || window.location.href.indexOf('amazon-ranking-dashboard') > -1) ? <ListGroup.Item as="li" bsPrefix=" " className='px-0'>
          <TargetingSettings />
        </ListGroup.Item> : null}
        {window.location.pathname.includes('amazon/marketing-stream') && lastUpdateTime && isTodayDateRange && (
          <ListGroup.Item as="li" bsPrefix=" " className='nav_datepicker d-none d-lg-inline-block data-time-badge-container'>
            <CustomTooltip 
              title={
                <span className="tooltip-content-with-line-height">
                  Till this hour (<span className="f-w-600 text-dark">{lastUpdateTime.trim()}</span>) data is being updated through the marketing stream services.
                </span>
              } 
              placement={'bottom'}
            >
              <div className={`bg-white p-3 text-dark d-flex align-items-center f-w-500 f-12 cursor-pointer rounded-8 calender_style date-time-badge ${theme?.theme === 'DARK' ? 'dark' : 'light'}`}>
                <Clock className="clock-icon" />
                <div className="d-flex align-items-center f-10 gap-3">
                  <span className='f-w-600'>Last Update on: </span>
                  <span className='f-w-700'>{lastUpdateTime.trim()} - ({getTimeZoneAbrv()})</span>
                </div>
              </div>
            </CustomTooltip>
          </ListGroup.Item>
        )}
        
        { !isMobileOrTablet && window.location.pathname !== '/amazon-dsp-request/create' && window.location.href.indexOf('amazon-dsp') > -1 ? <ListGroup.Item as="li" bsPrefix=" ">
        {amzDspState.activeTab === 3 &&  <TargetingDSPSettings /> }
        </ListGroup.Item> : null}
        {/* {window.location.pathname === '/amazon-dsp/marketing-stream' && window.location.href.indexOf('amazon-dsp') > -1 ? <ListGroup.Item as="li" bsPrefix=" ">
          <TargetingDSPSettings />
        </ListGroup.Item> : null} */}
        {window.location.href.indexOf('amazon') > -1 && (window.location.href.indexOf('snapshot') > -1 || window.location.href.indexOf('master-overview') > -1) && isToday(payloadState?.dateRange?.startDate) && isToday(payloadState?.dateRange?.endDate) && <ListGroup.Item as="li" bsPrefix=" ">
          <TimeBadgeClock defaultDateInfo={payloadState?.dateRange} />
        </ListGroup.Item>}
        {window.location.pathname.includes('app-user-tracking') || window.location.pathname.includes('master-dayparting-tracking') || window.location.pathname.includes('master-error-tracking') || window.location.href.indexOf('categorization') == -1 && (window.location.href.indexOf('master-overview') > -1 || window.location.href.indexOf('snapshot') > -1 || (window.location.href.indexOf('amazon') > -1 && !hideSectionsFortheLogPages ) || window.location.href.indexOf('flipkart') > -1 || window.location.href.indexOf('myntra') > -1 || window.location.href.indexOf('blinkit') > -1 || window.location.href.indexOf('activity') > -1) || window.location.href.indexOf('instamart') > -1 || window.location.href.indexOf('dsp-invoice-history') > -1 || ((window.location.href.indexOf('billing-payments') > -1 || window.location.href.indexOf('sponsored-ads') > -1) && !hideBillingCalendar) || window.location.href.indexOf('summary/zepto') > -1  || window.location.href.indexOf('summary/bigbasket') > -1 || window.location.href.indexOf('/admin/hector-registration') > -1 ?
          <ListGroup.Item as="li" bsPrefix=" " className='nav_datepicker d-none d-lg-inline-block'>
            {window.location.pathname.indexOf('campaign-drafts') == -1 && window.location.pathname !== '/amazon-dsp-request/create' && window.location.pathname.indexOf('amazon-audience-instance') == -1 && window.location.pathname !== '/amazon-view-audience' && window.location.pathname !== '/amazon-path-to-conversion' && window.location.pathname !== '/amazon-insights' && window.location.pathname !== '/amazon-audience-instance' && window.location.pathname !== '/amazon-tentpole-report' && window.location.pathname !== '/amazon-custom-attribution' && window.location.pathname !== '/amazon-time-to-conversion' && window.location.pathname !== '/amazon-create-audience' && window.location.pathname !== '/amazon-first-party-data' && !window.location.pathname.includes('amazon-first-party-demo-data') && window.location.pathname !== '/amazon-audience-report' && window.location.pathname !== '/amazon-chatgpt' && window.location.pathname !== '/amazon/smart-campaigns/drafts' && ((window.location.pathname.indexOf('amazon-automated-rules') > -1 && window.location.pathname.includes('view-')) || window.location.pathname.indexOf('amazon-automated-rules') == -1) && ((window.location.pathname.indexOf('amazon-dsp-automated-rules') > -1 && window.location.pathname.includes('view-')) || window.location.pathname.indexOf('amazon-dsp-automated-rules') == -1) && ((window.location.pathname.indexOf('amazon-dsp-automated-rules') > -1 && window.location.pathname.includes('view-')) || window.location.pathname.indexOf('amazon-dsp-automated-rules') == -1) && window.location.pathname.indexOf('amazon-dsp-user-management') == -1 && ((window.location.pathname.indexOf('flipkart-automated-rules') > -1 && window.location.pathname.includes('view-')) || window.location.pathname.indexOf('flipkart-automated-rules') == -1) && !window.location.pathname.includes('/amazon-view-audience') && !window.location.pathname.includes('amazon/restricted') && window.location.href.indexOf('amazon-ranking-configuration') == -1 && window.location.href.indexOf('amazon-ranking-activity') == -1 && !isDspCampaignCreateOrUpdate && <Calendar
              isCalendarOnly={1}
              // isSnapshot={true}
              availableColumns={[]}
              // compare={1}
              classes="no_absol f-10"
              preDateSelected={datePayload}
              onEmitDateRange={(ranges, compare, currentDateRangeFormat) => {
                // localStorage.setItem(`local-date-payload${String(window.location.pathname).replace(/\//g, '-')}`, JSON.stringify({ ...ranges, compare, currentDateRangeFormat }));
                (async () => {
                  try {
                    await idb.setDateConfig(`DateRangeDB${String(window.location.pathname).replace(/\//g, '-')}`, { ...ranges, compare, currentDateRangeFormat });
                  } catch (err) {
                    console.log('err', err)
                  }
                })()
                payloadDispatch({ type: 'UPDATE_DATE_RANGE', payload: { ...ranges, compare, currentDateRangeFormat } })
              }}
              defaultCalendar={1}
              showCompareInfo={window.location.pathname.includes('/amazon/cpc-job-listing') ||  window.location.pathname.includes('view-logs') ? false : true}
            />}
            {((window.location.pathname === '/amazon-path-to-conversion')) &&
              <>
                {<CampaignContext.Provider value={{ receivedCampaigns, setCampaignsData }}>
                    <AmcMultilevel  onCampaignReceive={handleCampaignData} appliedCampaigns={storedCampaignsData}/>
                </CampaignContext.Provider>}
                <DataPathContext.Provider value={{ receiveData, setReceiveData }}>
                  <div ref={wrapperRef}>
                    <button className='btn path-btn' onClick={handleToggleCalendar}><img src="/static/media/calender.4a8ef0a9.svg" alt="date_picker" class="wid-20 mr-2" />
                      <span>{receiveData ? (newCurrentDay.toDateString() + ' - ' + newEndDay.toDateString()) : (new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 6) % 7 - 7)).toDateString() + ' - ' + new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 7) % 7)).toDateString())} </span>
                    </button>
                    {calendarToggle && <div className='path-calendar-area bg-white'>
                      <PathCalendar onDataReceive={handleDataReceive} history={receiveData} weeklyBiweelyData={weeklyBiweelyData} compare={amcCompare} setCompare={setAmcCompare} />
                      <Row className="mx-2">
                        <Col sm={6} className="d-flex align-items-center justify-content-start pl-0">
                          <p className='data-alert'> <Tooltip
                              title={`If alternate Mondays are enabled, biweekly data (fully attributed) will be available; otherwise, only weekly data (partial attributed) will be accessible`}
                              position="top"
                              trigger="mouseenter"
                              arrow={true}
                              interactive={true}
                              animation="shift"
                              animateFill={true}
                            >
                              <img src={infoIcon} alt="info" className="cursor-pointer wid-13 ml-2" />
                            </Tooltip> Data available from 1st July 2024 </p>
                      </Col>
                      <Col sm={6} className="d-flex align-items-center gap-10 justify-content-end pr-0">
                          <button variant="contained" style={{ border: 0 }} className="btn-cancel" fullWidth onClick={(e) => showPtcCalendar(!calendarToggle)} sx={{ fontSize: '12px' }}>
                            Cancel
                          </button>
                          <button variant="contained" style={{ border: 0 }} className="btn-apply" fullWidth onClick={(e) => calendarApply()} sx={{ fontSize: '12px' }} disabled={!amcCompare && receiveData?.currentDay === receiveData?.endDay}>
                            Apply
                          </button>
                      </Col>
                      </Row>
                    </div>}
                  </div>
                </DataPathContext.Provider>
              </>
            }

            {(window.location.pathname === '/amazon-custom-attribution' || window.location.pathname.includes('amazon-first-party-demo-data')) &&
              <>
                <DataPathContext.Provider value={{ receiveData, setReceiveData }}>
                  <div ref={wrapperRef}>
                    <button className='btn path-btn' onClick={handleToggleCalendar}><img src="/static/media/calender.4a8ef0a9.svg" alt="date_picker" class="wid-20 mr-2" />
                      <span>{receiveData ? (newCurrentDay.toDateString() + ' - ' + newEndDay.toDateString()) : (new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 6) % 7 - 7)).toDateString() + ' - ' + new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 7) % 7)).toDateString())} </span>
                    </button>
                    {calendarToggle && <div className='path-calendar-area bg-white'>
                      <PathCalendar onDataReceive={handleDataReceive} history={receiveData} weeklyBiweelyData={weeklyBiweelyData} compare={amcCompare} setCompare={setAmcCompare} currentPath={location.pathname} />
                      <Row className="mx-2">
                        <Col sm={6} className="d-flex align-items-center justify-content-start pl-0">
                          {window.location.pathname !== '/amazon/search-query-performance' && <p className='data-alert'> <Tooltip
                              title={`If alternate Mondays are enabled, biweekly data (fully attributed) will be available; otherwise, only weekly data (partial attributed) will be accessible`}
                              position="top"
                              trigger="mouseenter"
                              arrow={true}
                              interactive={true}
                              animation="shift"
                              animateFill={true}
                            >
                              <img src={infoIcon} alt="info" className="cursor-pointer wid-13 ml-2" />
                            </Tooltip> Data available from 1st July 2024 </p>}
                      </Col>
                      <Col sm={6} className="d-flex align-items-center gap-10 justify-content-end pr-0">
                          <button variant="contained" style={{ border: 0 }} className="btn-cancel" fullWidth onClick={(e) => showPtcCalendar(!calendarToggle)} sx={{ fontSize: '12px' }}>
                            Cancel
                          </button>
                          <button variant="contained" style={{ border: 0 }} className="btn-apply" fullWidth onClick={(e) => calendarApply()} sx={{ fontSize: '12px' }} disabled={!amcCompare && receiveData?.currentDay === receiveData?.endDay}>
                            Apply
                          </button>
                      </Col>
                      </Row>
                    </div>}
                  </div>
                </DataPathContext.Provider>
              </>
            }
            {((window.location.pathname === '/amazon-time-to-conversion')) &&
              <>
                    
                <DataPathContext.Provider value={{ receiveData, setReceiveData }}>
                <div ref={wrapperRef}>
                  <button className='btn path-btn' onClick={handleToggleCalendar}><img src="/static/media/calender.4a8ef0a9.svg" alt="date_picker" class="wid-20 mr-2" /> 
                  <span>{receiveData ? (newCurrentDay.toDateString() + ' - ' + newEndDay.toDateString()) : (new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 6) % 7 - 7)).toDateString() + ' - ' + new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 7) % 7)).toDateString())} </span>
                  </button>
                  {calendarToggle && <div className='path-calendar-area bg-white'>
                    {console.log('NavRight passing path to PathCalendar:', location.pathname)}
                    <PathCalendar onDataReceive={handleDataReceive} history={receiveData} weeklyBiweelyData={weeklyBiweelyData} compare={amcCompare} setCompare={setAmcCompare} currentPath={location.pathname} />
                    {/* <Row style={{ margin: '10px', gap: '10px', display: 'flex', justifyContent: 'flex-start' }}>
                      <p className='data-alert'> <Tooltip
                        title={`If alternate Mondays are enabled, biweekly data (fully attributed) will be available; otherwise, only weekly data (partial attributed) will be accessible`}
                        position="top"
                        trigger="mouseenter"
                        arrow={true}
                        interactive={true}
                        animation="shift"
                        animateFill={true}
                      >
                        <img src={infoIcon} alt="info" className="cursor-pointer wid-13 ml-2" />
                      </Tooltip> Data available from 1st July 2024 </p>

                      <p className='path-note'>

                        <span style={{fontWeight:'600'}}>Note: </span> <span></span>
                      </p>
                    </Row> */}
                    <Row className="mx-2">
                      <Col sm={6} className="d-flex align-items-center justify-content-start pl-0">
                      <p className='data-alert'> <Tooltip
                          title={`If alternate Mondays are enabled, biweekly data (fully attributed) will be available; otherwise, only weekly data (partial attributed) will be accessible`}
                          position="top"
                          trigger="mouseenter"
                          arrow={true}
                          interactive={true}
                          animation="shift"
                          animateFill={true}
                        >
                          <img src={infoIcon} alt="info" className="cursor-pointer wid-13 ml-2" />
                        </Tooltip> Data available from 1st July 2024 </p>
                      </Col>
                      <Col sm={6} className="d-flex align-items-center gap-10 justify-content-end pr-0">
                        <button variant="contained" style={{ border: 0 }} className="btn-cancel" fullWidth onClick={(e) => showPtcCalendar(!calendarToggle)} sx={{ fontSize: '12px' }}>
                          Cancel
                        </button>
                        <button variant="contained" style={{ border: 0 }} className="btn-apply" fullWidth onClick={(e) => calendarApply()} sx={{ fontSize: '12px' }} disabled={!amcCompare && receiveData?.currentDay === receiveData?.endDay}>
                          Apply
                        </button>
                      </Col>
                    </Row>
                  </div>}
                  </div>
                </DataPathContext.Provider>
              </>
            }
          </ListGroup.Item> : null}
          { !isMobileOrTablet && (window.location.href.includes('amazon') || window.location.pathname === '/dsp-credit-top-up' ||  (window.location.href.includes('billing-payments') && !hideAccountsDropdown)) && <React.Fragment key={`${String(window.location.pathname).replaceAll('/', '').replaceAll(':','')}`}>
          {(activeProfiles &&
            activeProfiles?.length > 0 && !isSuperAdmin) ? (
            <ListGroup.Item as="li" bsPrefix=" " className="nav_acc_slct ch_toggle country-select-responsive">
              <Dropdown alignRight={!rtlLayout} className="select-account" show={showAccDropdown} onToggle={setAccDropdown}>
                <Dropdown.Toggle as="li" id="dropdown-basic" onClick={setAccDropdown} className="cursor-pointer">
                  <div className="text-right d-flex flex-column l-base align-items-end pr-2 drop-crd">
                    <div className="f-w-600 f-14 d-flex align-items-center text-left">
                      {/* <img
                      src={`https://img.mobiscroll.com/demos/flags/${defaultActive?.map((select) => select?.countryCode)}.png`}
                      alt=""
                      className="wid-30 mr-2"
                    /> */}
                      <img
                        src={
                          getCountryFlagUrl(defaultActive?.map((select) => select?.countryCode))
                        }
                        alt=""
                        className="country_flag_drop"
                      />
                      <div className="d-flex flex-column f-10 f-333843">
                        {defaultActive?.map((select) => replaceString(select?.accountInfo?.name))}
                        {defaultActive?.map((select, index) =>
                          select.accessLevel ? (
                            <span className="f-10 text-left w-100 f-w-500 spld-bder f-8F8F91" key={index}>
                              Role: <b className="f-w-600 f-10 f-333843">{select.accessLevel}</b>
                            </span>
                          ) : (
                            <span className="f-10 text-left w-100 f-w-500 spld-bder" key={index}>
                              Role: <b className="f-w-600 f-10">Admin</b>
                            </span>
                          )
                        )}
                      </div>
                    </div>
                    {/* <small className="f-10 bg-blur px-2 py-1 rounded-10 txt-theme">{defaultActive?.map((select) => select?.countryCode)}</small> */}
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu alignRight className="themebg notification notification-scroll">
                  {showAccDropdown && <>
                  <div className="noti-head">
                    <div className="countrySelection ">
                      <AccountsReset />
                      {showAccDropdown && countrySelected?.code ? (
                        <CustomCountryDropdown className="nav-item" onSelect={handleSelectCountry} countryCode={countrySelected?.code} />
                      ) : null}
                    </div>
                  </div>
                  <div className="px-3 pt-3 pb-1">
                    <Search searchValue={valueSearch} callBack={searchInputHandle} />
                  </div>
                  <PerfectScrollbar className="min-hight-150 max-height-300">
                    <ListGroup as="ul" bsPrefix=" " variant="flush" className="noti-body">
                      {(getTableRows()?.filter((rows) => rows.countryCode?.toLowerCase() == countrySelected?.code?.toLowerCase())?.length >
                        0 &&
                        getTableRows()
                          ?.filter((rows) => rows.countryCode?.toLowerCase() == countrySelected?.code?.toLowerCase())
                          ?.map((AMSprofiles, index) => {
                            const profile = (AMSprofiles?.newDsp || []).length > 0
                              ? { ...AMSprofiles, dsp: [...AMSprofiles?.dsp, ...(AMSprofiles?.newDsp || [])] }
                              : AMSprofiles;
                            const isActiveProfile = defaultActive?.[0]?.accessLevel == profile.accessLevel && defaultActive?.[0]?.profileId === profile.profileId && defaultActive?.[0]?.profileId === profile.profileId && defaultActive?.[0]?.accountInfo?.type === profile?.accountInfo?.type; 
                            return (
                              <ListGroup.Item
                                as="li"
                                bsPrefix=" "
                                className={'n-title px-0 pt-2'}
                                key={index}
                                onClick={() => handleSelect(profile)}
                              >
                                <Link
                                  to="#"
                                  className={`dropdown-item d-flex align-items-center justify-content-between ${isActiveProfile ? 'active' : ''
                                    }`}
                                >
                                  <section className="d-flex align-items-center">
                                    {/* <img
                                  src={`https://img.mobiscroll.com/demos/flags/${AMSprofiles?.countryCode}.png`}
                                  alt=""
                                  className="wid-30 hei-25 mr-4"
                                /> */}
                                    <img
                                      src={getCountryFlagUrl(AMSprofiles?.countryCode)}
                                      alt=""
                                      className="wid-30 hei-25 mr-4"
                                    />
  
                                    <div title={replaceString(AMSprofiles?.accountInfo?.name)}>
                                      <h4 className="mb-2 f-w-600 f-14 d-flex align-items-center">
                                        {' '}
                                        <span className="profile-name-truncate">{replaceString(AMSprofiles?.dsp?.[0]?.dspBrandName || AMSprofiles?.accountInfo?.name)} </span>
                                        <p
                                          className={`f-w-500 f-14 ml-2 mb-0 d-flex align-items-center ${
                                            AMSprofiles?.accountInfo?.type === 'seller'
                                            ? 'txt-theme'
                                            : AMSprofiles?.accountInfo?.type === 'DSP'
                                              ? 'text-dsp'
                                              : 'text-success'
                                            }`}
                                        >
                                          ({AMSprofiles?.accountInfo?.type})
                                          {AMSprofiles?.accountInfo?.type === 'DSP' && (
                                            <span className="ml-1">
                                              <StarIcon fillColor={'#FFBD40'}/>
                                            </span>
                                          )}
                                        </p>
                                      </h4>
  
                                      {AMSprofiles?.accessLevel ? (
                                        <p className="f-13 mb-0 f-w-500">
                                          Role: &nbsp; <b className="f-w-600 pr-1">{AMSprofiles?.accessLevel}</b> |{' '}
                                          <a
                                            className="cursor-pointer profile_link f-12 pl-1"
                                            target="_blank"
                                            href={encodeURIComponent(AMSprofiles?.url)}
                                          >
                                            {AMSprofiles?.accountInfo?.id}
                                          </a> 
                                          {/* <small className="">{(AMSprofiles?.seat === "neon")  ? `| (New)` : (AMSprofiles?.seat === "mixshift") ? `| (Old)` : ''}</small> */}
                                        </p>
                                      ) : (
                                        ''
                                      )}
                                      {process.env.REACT_APP_ADMIN_ACCESS_EMAIL.indexOf(commonState?.userInfo?.email) > -1 &&
                                        (('clientEmail' in AMSprofiles &&
                                          AMSprofiles.clientEmail != null &&
                                          AMSprofiles.clientEmail != '' &&
                                          AMSprofiles.clientEmail != commonState?.userInfo?.email) ||
                                          ('client_email' in AMSprofiles &&
                                            AMSprofiles.client_email != null &&
                                            AMSprofiles.client_email != '' &&
                                            AMSprofiles.client_email != commonState?.userInfo?.email)) ? (
                                        <p
                                          className="f-13 mb-0 f-w-500 profile-truncate"
                                          title={AMSprofiles.clientEmail ? AMSprofiles.clientEmail : AMSprofiles.client_email}
                                        >
                                          Owned By:{' '}
                                          <b className="f-w-600 pr-1">
                                            {AMSprofiles.clientEmail ? AMSprofiles.clientEmail : AMSprofiles.client_email}
                                          </b>
                                        </p>
                                      ) : (
                                        ''
                                      )}
                                      {/* <p className="f-13 mb-0 f-w-500">{AMSprofiles.profileId}</p> */}
                                      {/* <p className="f-12 text-secondary f-w-500 d-flex align-items-center"> */}
                                    </div>
                                  </section>
                                </Link>
                              </ListGroup.Item>
                            )
                          })) ||
                        (getTableRows()?.filter((rows) => rows?.countryCode?.toLowerCase() == countrySelected?.code?.toLowerCase())?.length ===
                          0 && (
                            <div className="hei-300 w-100 d-flex align-items-center justify-content-center f-w-700 txt-danger">
                              {' '}
                              No Profiles Found
                            </div>
                          ))}
                    </ListGroup>
                  </PerfectScrollbar>
                  {isAgencyUser && 
                    <div className="noti-footer py-2 text-left">
                      <Link to="/addaccount">Add a new account</Link>
                    </div>
                  }
                  </>}
                </Dropdown.Menu>
              </Dropdown>
            </ListGroup.Item>
          ) : (activeProfiles &&
            activeProfiles?.length > 0 && isSuperAdmin) ? (
            <AmazonProfiles rtlLayout={rtlLayout} activeCopyProfiles={activeProfiles} listTotalCount={listTotalCount} />
          ) : null}
        </React.Fragment>}

        {window.location.href.includes('flipkart') ? <FlipkartProfiles /> : null}
        {window.location.href.includes('instamart') ? <InstamartProfiles /> : null}
        {window.location.href.includes('myntra') ? <MyntraProfiles /> : null}
        {window.location.href.includes('blinkit') ? <BlinkitProfiles /> : null}
        {window.location.href.includes('zepto') ? <ZeptoProfiles /> : null}
        {window.location.href.includes('bigbasket') ? <BigbasketProfiles /> : null}

        {process.env.REACT_APP_BUG_ENABLE === 1 ? (
          <ListGroup.Item as="li" bsPrefix=" ">
            <BugModal header={1} />
          </ListGroup.Item>
        ) : null}
         {/* <ListGroup.Item as="li" bsPrefix=" " className='d-none d-lg-inline-block'>
          {!isFullScreen ? <Maximize size={18} onClick={enableFullscreen} className="themeicn cursor-pointer hover-theme" /> : null}
          {isFullScreen ? <Minimize size={18} onClick={enableFullscreen} className="themeicn cursor-pointer hover-theme" /> : null}
          <i className="feather icon-maximize cursor-pointer hover-theme" onClick={enableFullscreen}></i>
        </ListGroup.Item> */}
        {ParseData?.email != 'admin@hectorai.live' && ParseData?.email != 'prathmesh@hectorai.live' && !hideSectionsFortheLogPages && ((location.pathname.includes('/amazon') && localSelectedProfileId && localSelectedProfileId?.ams?.connected == true) || (location.pathname.includes('/amazon-dsp') && localSelectedProfileId && localSelectedProfileId?.dsp?.length > 0)) && !window.location.pathname.includes('amazon/restricted')  && <ListGroup.Item as="li" bsPrefix=" ">
          <Notification />
        </ListGroup.Item>}

        {/* {process.env.REACT_APP_THEME_ENABLE === '1' && (
          <ListGroup.Item as="li" bsPrefix=" " className='d-none d-lg-inline-block'>
            <ThemeSwitcher />
            <StyleTag />
          </ListGroup.Item>
        )} */}

        {/* Mobile/Tablet Sidebar Toggle Button */}
        {isMobileOrTablet && (
          <ListGroup.Item as="li" bsPrefix=" " className="mobile-sidebar-toggle d-lg-none">
            <button
              onClick={() => {
                commonDispatch({ type: 'TOGGLE_SIDEBAR' });
              }}
              className="btn btn-link p-0 border-0"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                color: theme?.theme === 'DARK' ? '#fff' : '#333',
                cursor: 'pointer'
              }}
              aria-label="Toggle sidebar"
            >
              {commonState.sidebarCollapsed ? (
                <Menu size={20} className="themeicn" />
              ) : (
                <X size={20} className="themeicn" />
              )}
            </button>
          </ListGroup.Item>
        )}

        {isNavigatingButton && <ListGroup.Item as="li" bsPrefix=" ">
            <div className="mcp-outline-link"
            onClick={() => {
              if (isProfile) {
                history.push('/connect-mcp');
              } else {
                history.push('/profile');
              }
            }}
            >
              {isProfile ? 'MCP' : 'Brand'}
            </div>
        </ListGroup.Item>}
        

        {/* <div className="mcp-outline-link">
            Brand
        </div> */}

      {isMobileOrTablet && <ListGroup.Item as="li" bsPrefix=" " className='pr-0'>
          <Dropdown alignRight={!rtlLayout} className="drp-user mobile-profile-dropdown" show={showProfDropdown} onToggle={setProfDropdown}>
            <Dropdown.Toggle as="li" id="dropdown-basic" onClick={setProfDropdown}>
              {/* <i className="feather icon-user" /> */}
              <span className={`profile-toggle-icon${shouldShowWhatsappVerification ? ' profile-toggle-icon--blink' : ''}`}>
                {/* <User size={18} className="themeicn cursor-pointer hover-theme" /> */}
                <div className="user-profile-avatar">
                  {commonState?.userInfo?.fullName?.charAt(0)}
                </div>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight className="profile-notification account-dropdown-menu">
              <div className="account-dropdown-header">
                <span className="account-dropdown-title">My Account</span>
              </div>
              <div className="account-dropdown-divider"></div>
              <div className="account-dropdown-menu-items">
                <div className="account-menu-item" onClick={() => { setProfDropdown(false); history.push('/edit-profile'); }}>
                  <div className="account-menu-icon">
                    <User size={16} />
                  </div>
                  <span className="account-menu-text">Profile Settings</span>
                </div>
                <div className="account-menu-item" onClick={() => { setProfDropdown(false); history.push('/edit-profile?tab=change-password'); }}>
                  <div className="account-menu-icon">
                    <Key size={16} />
                  </div>
                  <span className="account-menu-text">Change Password</span>
                </div>
                {ParseData?.planDetails?.salesbricksSubscriptionId && (
                  <>
                    <div className="account-menu-item" onClick={() => {
                      setProfDropdown(false);
                      services.postService({ url: '/salesbricks/customer/manage-subscription-link', nodeAPI: 1, payload: {} })
                        .then((res) => {
                          const url = res?.data?.result?.url;
                          if (url) window.open(url, '_blank');
                        })
                        .catch((err) => console.error('Manage subscription link error:', err));
                    }}>
                      <div className="account-menu-icon">
                        <Crosshair size={16} />
                      </div>
                      <span className="account-menu-text">Manage Subscription</span>
                    </div>
                    {!ParseData?.planDetails?.only_mcp && (
                      <div className="account-menu-item" onClick={() => { setProfDropdown(false); history.push('/amazon-user-management'); }}>
                        <div className="account-menu-icon">
                          <Users size={16} />
                        </div>
                        <span className="account-menu-text">User Management</span>
                      </div>
                    )}
                  </>
                )}
                <div className="account-menu-item" onClick={() => { setProfDropdown(false); history.push('/profile'); }}>
                  <div className="account-menu-icon">
                    <Tool size={16} />
                  </div>
                  <span className="account-menu-text">Account Access</span>
                </div>
              </div>
              <div className="account-dropdown-divider"></div>
              <div className="account-dropdown-menu-items">
                <div className="account-menu-item account-menu-item-logout" onClick={handleLogoutHandle}>
                  <div className="account-menu-icon">
                    <LogOut size={16} />
                  </div>
                  <span className="account-menu-text account-menu-text-logout">Logout</span>
                </div>
              </div>
              <LogoutModal show={showLogoutModal} onHide={handleCloseLogoutModal} handleLogout={handleLogout} loader={doLogoutSettings?.loading} />
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>}

        {!isMobileOrTablet && <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown alignRight={!rtlLayout} className="drp-user" show={showProfDropdown} onToggle={setProfDropdown}>
            <Dropdown.Toggle as="li" id="dropdown-basic" onClick={setProfDropdown}>
              {/* <i className="feather icon-user" /> */}
              <span className={`profile-toggle-icon${shouldShowWhatsappVerification ? ' profile-toggle-icon--blink' : ''}`}>
                <User size={18} className="themeicn cursor-pointer hover-theme" />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight className="profile-notification">
              <div className="pro-head d-flex align-items-center f-w-700">
                {/* <img src={userImg} className="img-radius mr-3" alt="User Profile" /> */}
                <span>
                  {commonState?.userInfo?.fullName}
                </span>
              </div>
              {isUserHasProfileAccess == true ? <ListGroup as="ul" bsPrefix=" " variant="flush" className="pro-body list-pad themebg">

                {shouldShowWhatsappVerification ? (
                  <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown} className='d-none d-lg-block'>
                    <a 
                      href="/edit-profile/verify-whatsapp" 
                      className={`themeicn dropdown-item f-w-500 d-flex align-items-center verify-whatsapp-item verify-whatsapp-item--blink`}
                      onClick={(e) => {
                        e.preventDefault();
                        // Store the current URL as referrer for redirect after verification
                        const referrerUrl = window.location.pathname + window.location.search;
                        sessionStorage.setItem('whatsapp-verify-referrer', referrerUrl);
                        commonDispatch({ type: 'OPEN_VERIFY_WHATSAPP_MODAL', payload: true });
                        history.push('/edit-profile/verify-whatsapp');
                      }}
                    >
                      <PhoneCall size={15} className="themeicn cursor-pointer mr-2" /> Verify Whatsapp
                    </a>
                  </ListGroup.Item>
                ) : null}
                
                {window.location.href.includes('amazon') && localSelectedProfileId?.ams?.connected == true ? (
                  <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown} className='d-none d-lg-block'>
                    <Link to="/profile" className="themeicn dropdown-item f-w-500 d-flex align-items-center">
                      <User size={15} className="themeicn cursor-pointer mr-2" /> Account Access
                    </Link>
                  </ListGroup.Item>
                ) : null}

                {isUserManagementVisible && (
                    <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown} className='d-none d-lg-block'>
                      <Link to={userManagementPath} className="themeicn dropdown-item f-w-500 d-flex align-items-center">
                            <UserCheck size={15} className="themeicn cursor-pointer mr-2" /> User Management
                      </Link>
                    </ListGroup.Item>
                )}

                {((isAmazon && localSelectedProfileId?.ams?.connected) || !isAmazon || (dspDetails?.enabledAsOnlyDSP && isUserFromAllowedDomain())) &&
                    isCategorizationShow &&
                    !isBlinkit &&
                    !window.location.href.includes('/profile') && (
                      <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown} className='d-none d-lg-block'>
                        <Link to={categorizationPath} className="themeicn dropdown-item f-w-500 d-flex align-items-center">
                          <FileText size={15} className="themeicn cursor-pointer mr-2" /> {isAmazon ? 'Asin' : 'Product'} Categorization
                        </Link>
                      </ListGroup.Item>
                )}

                {window.location.href.includes('/amazon-dsp') ? (
                    <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown} className='d-none d-lg-block'>
                      <Link to={"/amazon-dsp-text-categorization"} className="dropdown-item f-w-500 d-flex align-items-center">
                        <User size={15} className="cursor-pointer mr-2" /> Text Categorization
                      </Link>
                    </ListGroup.Item>
                  ) : ((isAmazon && localSelectedProfileId?.ams?.connected) || !isAmazon) &&
                    isCategorizationShow &&
                    !window.location.href.includes('/profile') && (
                      <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown} className='d-none d-lg-block'>
                        <Link to={textCategorizationPath} className="dropdown-item f-w-500 d-flex align-items-center">
                          <User size={15} className="cursor-pointer mr-2" /> Text Categorization
                        </Link>
                      </ListGroup.Item>
                )}

                {((window.location.href.includes('amazon') && localSelectedProfileId?.ams?.connected == true) || window.location.href.includes('amazon') == false) && isCategorizationShow && !window.location.href.includes("flipkart") && localSelectedProfileId?.accessLevel !== 'Executive' && !window.location.href.includes('/profile') && !window.location.href.includes("bigbasket") && (
                  <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown} className='d-none d-lg-block'>
                    <Link to="/amazon-blacklist-keywords" className="dropdown-item f-w-500 d-flex align-items-center">
                      <CloudDrizzle size={15} className="cursor-pointer mr-2" /> Blacklist Keywords
                    </Link>
                  </ListGroup.Item>
                )}

                {/* {isCategorizationShow && !window.location.href.includes("flipkart") && localSelectedProfileId?.accessLevel !== 'Executive' && (
                    <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown}>
                      <Link to="/rules" className="dropdown-item f-w-500 d-flex align-items-center">
                        <CloudDrizzle size={15} className="cursor-pointer mr-2" /> Automated Rules
                      </Link>
                    </ListGroup.Item>
                  )} */}

                {/* {isCategorizationShow && !window.location.href.includes("flipkart") && localSelectedProfileId?.accessLevel !== 'Executive' && (
                    <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown}>
                      <Link to="/blacklist" className="dropdown-item f-w-500 d-flex align-items-center">
                        <Settings size={15} className="cursor-pointer mr-2" /> Blacklist
                      </Link>
                    </ListGroup.Item>
                  )} */}

                {ParseData?.planDetails?.salesbricksSubscriptionId ? (
                    <>
                      <ListGroup.Item as="li" bsPrefix=" " className="themebg cursor-pointer" onClick={() => {
                        services.postService({ url: '/salesbricks/customer/manage-subscription-link', nodeAPI: 1, payload: {} })
                          .then((res) => {
                            const url = res?.data?.result?.url;
                            if (url) window.open(url, '_blank');
                          })
                          .catch((err) => console.error('Manage subscription link error:', err));
                          setProfDropdown();
                      }}>
                        <a className="themeicn dropdown-item f-w-500 d-flex align-items-center">
                          <Crosshair size={15} className="themeicn cursor-pointer mr-2" />
                          Manage Subscription
                        </a>
                      </ListGroup.Item>
                      {!ParseData?.planDetails?.only_mcp && (
                        <ListGroup.Item as="li" bsPrefix=" " className="themebg cursor-pointer" onClick={setProfDropdown}>
                          <a className="themeicn dropdown-item f-w-500 d-flex align-items-center" onClick={() => history.push('/amazon-user-management')}>
                            <Users size={15} className="themeicn cursor-pointer mr-2" />
                            User Management
                          </a>
                        </ListGroup.Item>
                      )}
                    </>
                ) : (isAmazon || isBillingSponsoredAdsDashboard) && ['admin','agency'].includes(localSelectedProfileId?.accessLevel?.toLowerCase()) && !window.location.href.includes('account-settings') ? (
                    <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown} className='d-none d-lg-block'>
                      <Link to="/account-settings" className="dropdown-item f-w-500 d-flex align-items-center">
                        <Crosshair size={15} className="cursor-pointer mr-2" /> Billing & User Management
                      </Link>
                    </ListGroup.Item>
                ) : null}

                {/* 
                  {!window.location.href.includes("flipkart") && process.env.REACT_APP_KEYWORD_CATEGORIZATION_ENABLE === '1' && localSelectedProfileId?.accessLevel !== 'Executive' && (
                    <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown}>
                      <Link to={window.location.href.includes("flipkart") ? "flipkart-text-categorization" : "/text-categorization"} className="dropdown-item f-w-500 d-flex align-items-center">
                        <User size={15} className="cursor-pointer mr-2" /> Text Categorization
                      </Link>
                    </ListGroup.Item>
                  )}

                  
        {/* 
                  {!window.location.href.includes("flipkart") && ParseData?.email !== 'admin@hectorai.live' && localSelectedProfileId?.accessLevel && localSelectedProfileId?.accessLevel.toLowerCase() === 'admin' && (
                    <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown}>
                      <Link to="/account-settings" className="themeicn dropdown-item f-w-500 d-flex align-items-center">
                        <Settings size={15} className="themeicn cursor-pointer mr-2" /> Settings
                      </Link>
                    </ListGroup.Item>
                  )} */}

                <ListGroup.Item as="li" bsPrefix=" " className="themebg cursor-pointer" onClick={setProfDropdown}>
                  <a className="themeicn dropdown-item f-w-500 d-flex align-items-center" onClick={() => history.push('/edit-profile')}>
                    <User size={15} className="themeicn cursor-pointer mr-2" />
                    Profile
                  </a>
                </ListGroup.Item>

                <ListGroup.Item as="li" bsPrefix=" " className="themebg cursor-pointer">
                  <a className="themeicn dropdown-item f-w-500 d-flex align-items-center" onClick={handleLogoutHandle}>
                    <LogOut size={15} className="themeicn cursor-pointer mr-2" />
                    Logout
                  </a>
                  <LogoutModal show={showLogoutModal} onHide={handleCloseLogoutModal} handleLogout={handleLogout} loader={doLogoutSettings?.loading} />
                </ListGroup.Item>
              </ListGroup> : 
              isOnlyDSPProfileAccess == true ? 
              <ListGroup as="ul" bsPrefix=" " variant="flush" className="pro-body list-pad themebg">
                {localSelectedProfileId?.accessLevel?.toLowerCase() != 'executive'  && (localSelectedProfileId?.dsp_only || localSelectedProfileId?.amcConnected) &&
                <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown} className='d-none d-lg-block'>
                <Link to={localSelectedProfileId?.amcConnected ? '/amazon-user-management' : '/amazon-dsp-user-management'} className="themeicn dropdown-item f-w-500 d-flex align-items-center">
                    <UserCheck size={15} className="themeicn cursor-pointer mr-2" /> Account User Management
                </Link>
                </ListGroup.Item>
                }  
              {window.location.href.includes('dsp') && <ListGroup.Item as="li" bsPrefix=" " onClick={setProfDropdown} className='d-none d-lg-block'>
                <Link to={"/amazon-dsp-text-categorization"} className="dropdown-item f-w-500 d-flex align-items-center">
                  <User size={15} className="cursor-pointer mr-2" /> Text Categorization
                </Link>
              </ListGroup.Item>}
              <ListGroup.Item as="li" bsPrefix=" " className="themebg cursor-pointer">
                <a className="themeicn dropdown-item f-w-500 d-flex align-items-center" onClick={handleLogoutHandle}>
                  <LogOut size={15} className="themeicn cursor-pointer mr-2" />
                    Logout
                </a>
                <LogoutModal show={showLogoutModal} onHide={handleCloseLogoutModal} handleLogout={handleLogout} loader={doLogoutSettings?.loading} />
              </ListGroup.Item> 
              </ListGroup> : <ListGroup as="ul" bsPrefix=" " variant="flush" className="pro-body list-pad themebg">
                <ListGroup.Item as="li" bsPrefix=" " className="themebg cursor-pointer" onClick={setProfDropdown}>
                  <a className="themeicn dropdown-item f-w-500 d-flex align-items-center" onClick={() => history.push('/edit-profile')}>
                    <User size={15} className="themeicn cursor-pointer mr-2" />
                    Profile Settings
                  </a>
                </ListGroup.Item>
                <ListGroup.Item as="li" bsPrefix=" " className="themebg cursor-pointer" onClick={setProfDropdown}>
                  <a className="themeicn dropdown-item f-w-500 d-flex align-items-center" onClick={() => history.push('/edit-profile?tab=change-password')}>
                    <Key size={15} className="themeicn cursor-pointer mr-2" />
                    Change Password
                  </a>
                </ListGroup.Item>
                {ParseData?.planDetails?.salesbricksSubscriptionId && (
                  <>
                    <ListGroup.Item as="li" bsPrefix=" " className="themebg cursor-pointer" onClick={() => {
                      setProfDropdown(false);
                      services.postService({ url: '/salesbricks/customer/manage-subscription-link', nodeAPI: 1, payload: {} })
                        .then((res) => {
                          const url = res?.data?.result?.url;
                          if (url) window.open(url, '_blank');
                        })
                        .catch((err) => console.error('Manage subscription link error:', err));
                    }}>
                      <a className="themeicn dropdown-item f-w-500 d-flex align-items-center">
                        <Crosshair size={15} className="themeicn cursor-pointer mr-2" />
                        Manage Subscription
                      </a>
                    </ListGroup.Item>
                    {!ParseData?.planDetails?.only_mcp && (
                      <ListGroup.Item as="li" bsPrefix=" " className="themebg cursor-pointer" onClick={setProfDropdown}>
                        <a className="themeicn dropdown-item f-w-500 d-flex align-items-center" onClick={() => history.push('/amazon-user-management')}>
                          <Users size={15} className="themeicn cursor-pointer mr-2" />
                          User Management
                        </a>
                      </ListGroup.Item>
                    )}
                  </>
                )}
                <ListGroup.Item as="li" bsPrefix=" " className="themebg cursor-pointer" onClick={setProfDropdown}>
                  <a className="themeicn dropdown-item f-w-500 d-flex align-items-center" onClick={() => history.push('/profile')}>
                    <Tool size={15} className="themeicn cursor-pointer mr-2" />
                    Account Access
                  </a>
                </ListGroup.Item>
                <ListGroup.Item as="li" bsPrefix=" " className="themebg cursor-pointer">
                  <a className="themeicn dropdown-item f-w-500 d-flex align-items-center" onClick={handleLogoutHandle}>
                    <LogOut size={15} className="themeicn cursor-pointer mr-2" />
                    Logout
                  </a>
                  <LogoutModal show={showLogoutModal} onHide={handleCloseLogoutModal} handleLogout={handleLogout} loader={doLogoutSettings?.loading} />
                </ListGroup.Item>
              </ListGroup>}
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>}
      </ListGroup>

      <PendingDspBrandSelectModal show={showDspBrandSelectModal} onHide={() => setShowDspBrandSelectModal(false)} handleDspBrandSelect={handleDspBrandSelect} />

      <ReAuthModal 
        show={showReAuthModal !== null}
        onHide={() => setShowReAuthModal(null)}
        accessLevel={showReAuthModal?.accessLevel}
        profileOwner={showReAuthModal?.profileOwner}
        profileName={showReAuthModal?.accountInfo?.name || showReAuthModal?.accountInfo?.sortName || ''}
        profileId={showReAuthModal?.profileId}
        onContinue={() => {
          const profileName = showReAuthModal?.accountInfo?.name || showReAuthModal?.accountInfo?.sortName || '';
          setShowReAuthModal(null);
          history.push(`/profile?search=${encodeURIComponent(profileName)}`);
        }}
        onSkip={() => {
          // Skip functionality removed - user must proceed
          setShowReAuthModal(null)
        }}
      />

      <ChatList listOpen={listOpen} closed={() => setListOpen(false)} />
      <StyleTag />
      {/* </ThemeProvider> */}
    </React.Fragment>
  );
};

export default NavRight;

const LogoutModal = ({ show, onHide, handleLogout, loader }) => {
  return (
    <Modal className="asin-modal" dialogClassName="new-re-auth-theme" show={show} onHide={onHide} centered>
      <Modal.Body className="pt-4" style={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
        <p className="f-16 f-w-600 py-1 text-center">Are you sure you want to logout?</p>
      </Modal.Body>
      <Modal.Footer className="gap-10 border-none justify-content-center pb-4">
        <Button className="btn f-14 cls-btn py-2 px-3 f-13 border-none" onClick={onHide}>
          Cancel
        </Button>
        <Button className="btn f-14 bg-blue text-white py-2 px-3 f-13 border-none d-flex align-items-center gap-10" onClick={handleLogout}>
          Logout
          {loader &&
            <Spinner animation="border" role="status" className='wid-15 hei-15'>
            </Spinner>
          }
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const PendingDspBrandSelectModal = ({ show, onHide }) => {
  return (
    <Modal className="asin-modal" dialogClassName="new-theme" show={show} onHide={onHide} centered>
      <Modal.Header className="bg-theme">
        <Modal.Title className="f-16 f-w-600">Account Activation Pending</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-4" style={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
        <p className="f-16 py-1 text-center">Your DSP Account is currently being processed. The activation process typically takes 48-72 hours.</p>
      </Modal.Body>
      <Modal.Footer className="gap-10 border-none justify-content-center pb-4">
        <Button className="btn f-14 bg-blue text-white py-2 px-3 f-13 border-none d-flex align-items-center gap-10" onClick={onHide}>
          Okay
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const ReAuthModal = ({ show, onHide, profileName, profileId, onContinue, onSkip, accessLevel = '', profileOwner = '' }) => {
  return (
    <Modal 
      className="asin-modal" 
      dialogClassName="new-theme" 
      show={show} 
      onHide={() => {}} 
      centered
    >
      <Modal.Body 
        className="d-flex flex-column align-items-center pt-4 pb-3 px-4" 
        style={{ 
          borderTopLeftRadius: '16px', 
          borderTopRightRadius: '16px',
          maxWidth: '520px',
          width: '100%',
          margin: '0 auto'
        }}
      >
        <div className="mb-3 d-flex align-items-center justify-content-center">
          <div className="sonar-wrapper">
            <div className="sonar-emitter">
              <img src={infoIcon} alt="info" className="z-1000" style={{ width: '60px', height: '60px' }} />
              <div className="sonar-wave-org"></div>
              <div className="sonar-wave-1-org"></div>
            </div>
          </div>
        </div>
        <div className="text-center w-100" style={{ maxWidth: '480px' }}>
          <h3 className="f-18 f-w-600 text-center mb-3" style={{ lineHeight: '28px', color: '#101828' }}>
            Your Amazon Ads account {profileName ? <strong>{profileName}</strong> : ''} is currently disconnected.
          </h3>
          <p className="f-14 f-w-400 text-center mb-0" style={{ lineHeight: '20px', color: '#667085' }}>
            To continue using Hector, please reauthorize your account. Click Proceed to go to the Profiles page, then select the Reauthorize{' ('}
            <IconButton 
              size="small" 
              className="p-0"
              title="Re-Authorize AMS access"
              style={{ verticalAlign: 'middle', margin: '0 2px' }}
            >
              <CableIcon fontSize="small" style={{ color: '#FF9800', fontSize: '16px' }} />
            </IconButton>{') '}
            icon next to the account to complete the Amazon authorization process.
          </p>

          {!(accessLevel == 'Admin' || accessLevel == 'Agency') && <p className="f-14 f-w-400 text-center mb-0" style={{ lineHeight: '20px', color: '#667085' }}> Note: Please contact admin ({profileOwner}) to re-authorize your account.</p>}
        </div>
      </Modal.Body>
      <Modal.Footer 
        className="gap-10 border-none justify-content-center pb-4 pt-3 px-4" 
        style={{ maxWidth: '520px', width: '100%', margin: '0 auto' }}
      >
        {accessLevel == 'Admin' || accessLevel == 'Agency' ? (
          <Button 
            className="btn f-14 bg-blue text-white py-2 px-5 f-13 border-none" 
            onClick={onContinue}
            style={{ minWidth: '120px' }}
          >
            Proceed
          </Button>
        ) : (
          <Button 
            className="btn f-14 bg-blue text-white py-2 px-4 f-13 border-none" 
            onClick={onSkip}
            style={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '100%' }}
          >
            Ok
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};